import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4, green6 } from 'approot/shared/styles/colours.style';
import {
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from '../activity-builder.constants';
import { PRESENT_PROGRESS_BAR_Z_INDEX } from './activity-builder-present.constants';

export const ProgressBarProgress = styled.div`
  background-color: ${green6};
  background:
    linear-gradient(
      180deg,
      rgba(246, 255, 237, 0.5) 0%,
      rgba(246, 255, 237, 0) 100%
    ),
    ${green6};
  border-radius: 0 4px 4px 0;
  height: 100%;
  transition: all 300ms ease;
  width: 0;
`;

type ProgressBarProps = {
  $progress: number;
  $isDrawerActive: boolean;
  $isDrawerDetailsActive: boolean;
};

export const ProgressBar = styled.div<ProgressBarProps>`
  background-color: ${grey4};
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%),
    ${grey4};
  height: ${rem(8)};
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  z-index: ${PRESENT_PROGRESS_BAR_Z_INDEX};
  border-radius: 0;

  ${({ $progress }) =>
    $progress &&
    `
    ${ProgressBarProgress} {
      width: ${$progress}%;
    }
  `}

  ${({ $isDrawerActive }) =>
    $isDrawerActive &&
    `
    right: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
  `}

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    ${({ $isDrawerDetailsActive }) =>
      $isDrawerDetailsActive &&
      `
      right: ${rem(
        ACTIVITY_BUILDER_SETTINGS_WIDTH + ACTIVITY_BUILDER_DRAWER_WIDTH
      )};
    `}
  }
`;
